<template>
  <v-card align="center" justify="center" light min-width="30vw" outlined>
    <v-card-title style="background-color: #d2d7e1">
      <v-list-item>
        <v-list-item-title><h2>{{ $t('allUserConsiderations') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="overflow-y-auto px-5 py-7" style="max-height: 70vh !important;">
      <v-container fluid>
        <v-row v-for="consideration in this.$store.state.user.considerations" v-bind:key="consideration.id" dense style="border-bottom: 1px solid #e3e3e3;">
          <v-col class="d-flex align-center justify-start" cols="9">
            <h3 class="my-0 text-start" style="font-size: 14px; color: #111111">{{ consideration.name }}</h3>
            <v-chip class="ml-2" :color="getConsiderationColor(consideration)" text-color="white" x-small><p class="my-0" style="font-size: 13px;">
              <v-icon class="mr-2" x-small>{{ getConsiderationIcon(consideration) }}</v-icon> {{ capitalize(consideration.type) }}</p>
            </v-chip>
          </v-col>
          <v-col class="d-flex align-center justify-end" cols="3">
            <v-chip small @click="removeConsideration(consideration)">
              <p class="my-0" style="font-size: 14px !important;">{{ $t('remove') }}
                <v-icon class="ml-1" x-small>fa-times</v-icon></p>
            </v-chip>
          </v-col>
        </v-row>
      </v-container>
      <v-btn @click="close">{{ $t('close') }}</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "SeeAllConsiderations",
  methods: {
    getConsiderationColor(consideration) {
      let considerationType = consideration.type;
      return (considerationType === 'HIT')? '#00a553' : (considerationType === 'MISTAKE')? '#f14400' : '#3b3b3b';
    },
    getConsiderationIcon(consideration) {
      let considerationType = consideration.type;
      return (considerationType === 'HIT')? 'fa-check' : (considerationType === 'MISTAKE')? 'fa-times' : 'fa-stop-circle';
    },
    removeConsideration(consideration) {
      this.$emit('removeConsideration', consideration);
    },
    capitalize(string) {
      return string[0] + string.slice(1).toLowerCase();
    },
    close() {
      this.$emit('closeWindow');
    },
  }
}
</script>

<style scoped>

</style>


<i18n>
{
  "en":{
    "allUserConsiderations": "All User Considerations",
    "remove": "Remove",
    "close": "Close"

  },
  "es":{
    "allUserConsiderations": "Todas las consideraciones del usuario",
    "remove": "Remover",
    "close": "Cerrar"
  }
}
</i18n>
